// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ExportProgressFields_EmployeeExportProgress_Fragment = { __typename?: 'EmployeeExportProgress' } & Pick<
  Types.EmployeeExportProgress,
  'id' | 'status' | 'createdAt' | 'updatedAt' | 'totalRequestCount' | 'completedRequestCount'
> & {
    createdBy: Types.Maybe<
      { __typename?: 'Employee' } & {
        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
          Types.EmployeeGeneralInformation,
          'preferredFullName'
        >;
      }
    >;
  };

export type ExportProgressFields_EmployeeImportProgress_Fragment = { __typename?: 'EmployeeImportProgress' } & Pick<
  Types.EmployeeImportProgress,
  'id' | 'status' | 'createdAt' | 'updatedAt' | 'totalRequestCount' | 'completedRequestCount'
> & {
    createdBy: Types.Maybe<
      { __typename?: 'Employee' } & {
        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
          Types.EmployeeGeneralInformation,
          'preferredFullName'
        >;
      }
    >;
  };

export type ExportProgressFields_ExternalAccountExportProgress_Fragment = {
  __typename?: 'ExternalAccountExportProgress';
} & Pick<
  Types.ExternalAccountExportProgress,
  'id' | 'status' | 'createdAt' | 'updatedAt' | 'totalRequestCount' | 'completedRequestCount'
> & {
    createdBy: Types.Maybe<
      { __typename?: 'Employee' } & {
        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
          Types.EmployeeGeneralInformation,
          'preferredFullName'
        >;
      }
    >;
  };

export type ExportProgressFields_ManagerialAccountingImportProgress_Fragment = {
  __typename?: 'ManagerialAccountingImportProgress';
} & Pick<
  Types.ManagerialAccountingImportProgress,
  'id' | 'status' | 'createdAt' | 'updatedAt' | 'totalRequestCount' | 'completedRequestCount'
> & {
    createdBy: Types.Maybe<
      { __typename?: 'Employee' } & {
        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
          Types.EmployeeGeneralInformation,
          'preferredFullName'
        >;
      }
    >;
  };

export type ExportProgressFields_NumberOfEmployeeExportProgress_Fragment = {
  __typename?: 'NumberOfEmployeeExportProgress';
} & Pick<
  Types.NumberOfEmployeeExportProgress,
  'id' | 'status' | 'createdAt' | 'updatedAt' | 'totalRequestCount' | 'completedRequestCount'
> & {
    createdBy: Types.Maybe<
      { __typename?: 'Employee' } & {
        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
          Types.EmployeeGeneralInformation,
          'preferredFullName'
        >;
      }
    >;
  };

export type ExportProgressFields_PerformanceReviewExportProgress_Fragment = {
  __typename?: 'PerformanceReviewExportProgress';
} & Pick<
  Types.PerformanceReviewExportProgress,
  'id' | 'status' | 'createdAt' | 'updatedAt' | 'totalRequestCount' | 'completedRequestCount'
> & {
    createdBy: Types.Maybe<
      { __typename?: 'Employee' } & {
        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
          Types.EmployeeGeneralInformation,
          'preferredFullName'
        >;
      }
    >;
  };

export type ExportProgressFields_ProbationReviewExportProgress_Fragment = {
  __typename?: 'ProbationReviewExportProgress';
} & Pick<
  Types.ProbationReviewExportProgress,
  'id' | 'status' | 'createdAt' | 'updatedAt' | 'totalRequestCount' | 'completedRequestCount'
> & {
    createdBy: Types.Maybe<
      { __typename?: 'Employee' } & {
        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
          Types.EmployeeGeneralInformation,
          'preferredFullName'
        >;
      }
    >;
  };

export type ExportProgressFieldsFragment =
  | ExportProgressFields_EmployeeExportProgress_Fragment
  | ExportProgressFields_EmployeeImportProgress_Fragment
  | ExportProgressFields_ExternalAccountExportProgress_Fragment
  | ExportProgressFields_ManagerialAccountingImportProgress_Fragment
  | ExportProgressFields_NumberOfEmployeeExportProgress_Fragment
  | ExportProgressFields_PerformanceReviewExportProgress_Fragment
  | ExportProgressFields_ProbationReviewExportProgress_Fragment;

export type ExportProgressEmployeeSubscriptionVariables = Types.Exact<{ [key: string]: never }>;

export type ExportProgressEmployeeSubscription = { __typename?: 'Subscription' } & {
  exportProgress: Array<
    { __typename?: 'EmployeeExportProgress' } & ExportProgressFields_EmployeeExportProgress_Fragment
  >;
};

export type ExportProgressNumberOfEmployeeSubscriptionVariables = Types.Exact<{ [key: string]: never }>;

export type ExportProgressNumberOfEmployeeSubscription = { __typename?: 'Subscription' } & {
  exportProgress: Array<
    { __typename?: 'NumberOfEmployeeExportProgress' } & ExportProgressFields_NumberOfEmployeeExportProgress_Fragment
  >;
};

export type ExportProgressPerformanceReviewSubscriptionVariables = Types.Exact<{
  types: Array<Types.PerformanceReviewExportType> | Types.PerformanceReviewExportType;
}>;

export type ExportProgressPerformanceReviewSubscription = { __typename?: 'Subscription' } & {
  exportProgress: Array<
    { __typename?: 'PerformanceReviewExportProgress' } & ExportProgressFields_PerformanceReviewExportProgress_Fragment
  >;
};

export type ExportProgressExternalAccountSubscriptionVariables = Types.Exact<{ [key: string]: never }>;

export type ExportProgressExternalAccountSubscription = { __typename?: 'Subscription' } & {
  exportProgress: Array<
    { __typename?: 'ExternalAccountExportProgress' } & ExportProgressFields_ExternalAccountExportProgress_Fragment
  >;
};

export type ExportProgressProbationReviewSubscriptionVariables = Types.Exact<{ [key: string]: never }>;

export type ExportProgressProbationReviewSubscription = { __typename?: 'Subscription' } & {
  exportProgress: Array<
    { __typename?: 'ProbationReviewExportProgress' } & ExportProgressFields_ProbationReviewExportProgress_Fragment
  >;
};

export const ExportProgressFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment ExportProgressFields on ExportImportProgress {
  id
  status
  createdAt
  updatedAt
  createdBy {
    generalInformation {
      preferredFullName
    }
  }
  totalRequestCount
  completedRequestCount
}
    `;
export const ExportProgressEmployeeDocument = /*#__PURE__*/ gql`
    subscription exportProgressEmployee {
  exportProgress: exportProgressEmployee {
    ...ExportProgressFields
  }
}
    ${ExportProgressFieldsFragmentDoc}`;

/**
 * __useExportProgressEmployeeSubscription__
 *
 * To run a query within a React component, call `useExportProgressEmployeeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExportProgressEmployeeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportProgressEmployeeSubscription({
 *   variables: {
 *   },
 * });
 */
export function useExportProgressEmployeeSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ExportProgressEmployeeSubscription,
    ExportProgressEmployeeSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<ExportProgressEmployeeSubscription, ExportProgressEmployeeSubscriptionVariables>(
    ExportProgressEmployeeDocument,
    options,
  );
}
export type ExportProgressEmployeeSubscriptionHookResult = ReturnType<typeof useExportProgressEmployeeSubscription>;
export const ExportProgressNumberOfEmployeeDocument = /*#__PURE__*/ gql`
    subscription exportProgressNumberOfEmployee {
  exportProgress: exportProgressNumberOfEmployee {
    ...ExportProgressFields
  }
}
    ${ExportProgressFieldsFragmentDoc}`;

/**
 * __useExportProgressNumberOfEmployeeSubscription__
 *
 * To run a query within a React component, call `useExportProgressNumberOfEmployeeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExportProgressNumberOfEmployeeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportProgressNumberOfEmployeeSubscription({
 *   variables: {
 *   },
 * });
 */
export function useExportProgressNumberOfEmployeeSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ExportProgressNumberOfEmployeeSubscription,
    ExportProgressNumberOfEmployeeSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ExportProgressNumberOfEmployeeSubscription,
    ExportProgressNumberOfEmployeeSubscriptionVariables
  >(ExportProgressNumberOfEmployeeDocument, options);
}
export type ExportProgressNumberOfEmployeeSubscriptionHookResult = ReturnType<
  typeof useExportProgressNumberOfEmployeeSubscription
>;
export const ExportProgressPerformanceReviewDocument = /*#__PURE__*/ gql`
    subscription exportProgressPerformanceReview($types: [PerformanceReviewExportType!]!) {
  exportProgress: exportProgressPerformanceReview(types: $types) {
    ...ExportProgressFields
  }
}
    ${ExportProgressFieldsFragmentDoc}`;

/**
 * __useExportProgressPerformanceReviewSubscription__
 *
 * To run a query within a React component, call `useExportProgressPerformanceReviewSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExportProgressPerformanceReviewSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportProgressPerformanceReviewSubscription({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useExportProgressPerformanceReviewSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ExportProgressPerformanceReviewSubscription,
    ExportProgressPerformanceReviewSubscriptionVariables
  > &
    ({ variables: ExportProgressPerformanceReviewSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ExportProgressPerformanceReviewSubscription,
    ExportProgressPerformanceReviewSubscriptionVariables
  >(ExportProgressPerformanceReviewDocument, options);
}
export type ExportProgressPerformanceReviewSubscriptionHookResult = ReturnType<
  typeof useExportProgressPerformanceReviewSubscription
>;
export const ExportProgressExternalAccountDocument = /*#__PURE__*/ gql`
    subscription exportProgressExternalAccount {
  exportProgress: exportProgressExternalAccount {
    ...ExportProgressFields
  }
}
    ${ExportProgressFieldsFragmentDoc}`;

/**
 * __useExportProgressExternalAccountSubscription__
 *
 * To run a query within a React component, call `useExportProgressExternalAccountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExportProgressExternalAccountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportProgressExternalAccountSubscription({
 *   variables: {
 *   },
 * });
 */
export function useExportProgressExternalAccountSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ExportProgressExternalAccountSubscription,
    ExportProgressExternalAccountSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ExportProgressExternalAccountSubscription,
    ExportProgressExternalAccountSubscriptionVariables
  >(ExportProgressExternalAccountDocument, options);
}
export type ExportProgressExternalAccountSubscriptionHookResult = ReturnType<
  typeof useExportProgressExternalAccountSubscription
>;
export const ExportProgressProbationReviewDocument = /*#__PURE__*/ gql`
    subscription exportProgressProbationReview {
  exportProgress: exportProgressProbationReview {
    ...ExportProgressFields
  }
}
    ${ExportProgressFieldsFragmentDoc}`;

/**
 * __useExportProgressProbationReviewSubscription__
 *
 * To run a query within a React component, call `useExportProgressProbationReviewSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExportProgressProbationReviewSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportProgressProbationReviewSubscription({
 *   variables: {
 *   },
 * });
 */
export function useExportProgressProbationReviewSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ExportProgressProbationReviewSubscription,
    ExportProgressProbationReviewSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ExportProgressProbationReviewSubscription,
    ExportProgressProbationReviewSubscriptionVariables
  >(ExportProgressProbationReviewDocument, options);
}
export type ExportProgressProbationReviewSubscriptionHookResult = ReturnType<
  typeof useExportProgressProbationReviewSubscription
>;
